import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-split-panel",
  "use": "icon-split-panel-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-split-panel\"><defs><style type=\"text/css\"></style></defs><path d=\"M960 32H64a32 32 0 0 0-32 32v896a32 32 0 0 0 32 32h896a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zM96 928V96h320v832H96z m384 0V96h64v832h-64z m448 0H608V96h320v832z\" p-id=\"4010\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/split-panel.svg
// module id = cqM4
// module chunks = 11